<template>
  <div class="main_box">
    <div class="body_title flex_layout_between">
      <h2>{{ $t('enum.auction') }}</h2>
      <div class="input_blue">
        <el-input :placeholder="$t('enum.searchForItems')" v-model="searchKey" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="getData()"></el-button>
        </el-input>
      </div>
    </div>
    <div class="ul_tab">
      <ul class="tab_menu">
        <li :class="isSort == 1 ? 'on' : ''" @click="AuctionSort('sortType', 1)">
          <span>{{ $t('enum.endingSoonest') }}</span>
        </li>
        <li class="p_slot" :class="isSort == 2 || isSort == 3 ? 'on' : ''" @click="AuctionSort('sortType', 2, 'Price')">
          <span>{{ $t('enum.price') }}
            <em class="up_arr" :class="sortType == 3 ? 'active' : ''"></em>
            <em class="up_down" :class="sortType == 2 ? 'active' : ''"></em>
          </span>
        </li>
        <li :class="isSort == 4 ? 'on' : ''" @click="AuctionSort('sortType', 4)">
          <span>{{ $t('enum.newlyReleased') }}</span>
        </li>
        <li :class="isSort == 5 ? 'on' : ''" @click="AuctionSort('sortType', 5)">
          <span>{{ $t('enum.mostBids') }}</span>
        </li>
      </ul>
      <div class="main_total">{{ Count }} {{ Count != 1 ? $t('enum.items') : $t('enum.item') }}</div>
    </div>
    <table-list :list="List" showType="auction" v-loading="loading" :loading="loading" @dialogSwitch="dialogSwitch" />
    <list-pagination v-show="Count > 0" ref="Pagination" :total="Count" @getData="getData" />

    <dialog-unload ref="UnloadDialog" v-if="dialogShow" :dialogType="dialogType" :dialogCardObj="dialogCardObj" @dialogSwitch="dialogSwitch" @getData="getData" @dialogClose="dialogClose"></dialog-unload>
  </div>
</template>

<script>
import TableList from '@/components/tablelist'
import ListPagination from '@/components/listpagination'
import DialogUnload from '@/components/dialog/dialog-unload'
import api from "@/api/api";
export default {
  name: '',
  components: { TableList, ListPagination, DialogUnload },
  data() {
    return {
      loading: true, //page loading
      isPrice: null,
      UserInfo: this.$store.state.UserInfo,
      List: [],
      Count: 0,
      searchKey: '',
      PageIndex: 1,
      PageSize: 60,
      byWay: 2,//2=拍卖,1=一口价
      listType: 1,//1=已上架，2=即将上架，3=已下架
      sortType: 1,//1=最快结束时间，2=价格（高-低），3=价格（低-高），4=最新发布，5出价次数（高-低）
      isSort: 1,
      /*unload-dialog*/
      dialogShow: false,
      dialogType: '',
      dialogCardObj: {},
    }
  },
  created: function () {
    var that = this;
  },
  mounted: function () {
    var that = this;
    var val = that.$route.params.sortType || 2;
    that.sortType = val
    that.isSort = val;
    // console.log("xxx", that.$route.params.sortType)
    that.getData();
  },
  methods: {
    // 弹框
    dialogSwitch(val, obj) {
      /*unload-dialog*/
      this.dialogShow = true;
      this.dialogType = val;
      if (obj) {
        this.dialogCardObj = obj;
      }
    },
    // 关闭弹框
    dialogClose() {
      this.dialogShow = false;
    },
    // 获取我的商品列表
    getData(PageIndex, PageSize) {
      var that = this;
      if (PageIndex && PageSize) { that.PageIndex = PageIndex; that.PageSize = PageSize; }
      let _searchKey = encodeURIComponent(that.searchKey);
      let params = `?pageIndex=${that.PageIndex}&pageSize=${that.PageSize}&searchKey=${that.searchKey}&byWay=${that.byWay}&listType=${that.listType}&sortType=${that.sortType}`;
      that.loading = true;
      that.List = [];
      that.Count = 0;
      let fun = function (res) {
        that.loading = false;
        console.log(res)
        if (res.result) {
          var _data = res.data
          that.List = _data;
          that.Count = res.count;
        }
      };
      that.$get('SearchMyCommodities', params)//我的 商品列表
        .then((res) => {
          console.log("axios-res:", res);
          fun(res);
        })
        .catch((err) => {
          console.log(err);
          that.loading = false;
        });
    },
    // 筛选物品的商品列表
    AuctionSort(type, val, key) {
      let that = this;
      // 排序价格
      if (key && key == 'Price') {
        val = that.sortType;
        if (val == 2) { val = 3 } else { val = 2; }
      }
      // 切换tab类型
      switch (type) {
        case 'sortType':
          that.sortType = val;
          break;
      }
      that.isSort = val;
      that.PageIndex = 1;
      if (that.$refs.Pagination) {
        that.$refs.Pagination.PageIndex = 1;
      }
      that.getData();
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/activetab.css";
</style>



// WEBPACK FOOTER //
// src/pages/commodity/active.vue